// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/course_section.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_planners_v1_resources_external_source } from "./external_source_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/course_section.proto.
 */
export const file_studyo_today_planners_v1_resources_course_section = /*@__PURE__*/
  fileDesc("CjdzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2NvdXJzZV9zZWN0aW9uLnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzIrcCCg1Db3Vyc2VTZWN0aW9uEgoKAmlkGAEgASgJEhIKCnBsYW5uZXJfaWQYAiABKAkSDQoFdGl0bGUYAyABKAkSDQoFY29sb3IYBCABKAkSSwoPZXh0ZXJuYWxfc291cmNlGAUgASgLMjIuc3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcy5FeHRlcm5hbFNvdXJjZRIwCgxjcmVhdGVkX3RpbWUYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjAKDHVwZGF0ZWRfdGltZRgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKc3luY190b2tlbhgIIAEoAxIPCgdzZWN0aW9uGAkgASgJEhIKCmlzX3Zpc2libGUYCiABKAhCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_studyo_today_planners_v1_resources_external_source]);

/**
 * Describes the message studyo.today.planners.v1.resources.CourseSection.
 * Use `create(CourseSectionSchema)` to create a new message.
 */
export const CourseSectionSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_course_section, 0);

